export class AppraisalsRoutePaths {
  static reviewAPage(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/reviews/new`;
  }

  static reviewAPageWithMethod(
    teamId: string,
    workspaceId: string,
    nodeId: string,
    method: 'accessibility' | 'refactoringui'
  ) {
    return `/${teamId}/${workspaceId}/reviews/new/${nodeId}/${method}`;
  }

  static reviewAPageAsAGuest() {
    return '/guest/reviews/new';
  }

  static appraisalDetails(teamId: string, workspaceId: string, appraisalId: string) {
    return `/${teamId}/${workspaceId}/reviews/${appraisalId}`;
  }

  static guestAppraisalDetails(teamId: string, workspaceId: string, appraisalId: string) {
    return `/guest/${teamId}/${workspaceId}/reviews/${appraisalId}`;
  }
}
